import React from 'react'
import { Link } from 'gatsby'
import { Breadcrumbs, BreadcrumbItem } from '@berlitz/breadcrumbs'
import { homeTranslations } from '../../functions/mapItems'

const BreadCrumbs = ({ homeUrl, crumbs, title, lang }) => {
  return (
    <Breadcrumbs
      crumbs={crumbs}
      currentPage={title}
      link={Link}
      homeUrl={homeUrl}
    >
      <BreadcrumbItem>
        <Link to={homeUrl}>{homeTranslations[lang] || 'Home'}</Link>
      </BreadcrumbItem>
    </Breadcrumbs>
  )
}

export default BreadCrumbs
